export default __webpack_public_path__ + "static/media/banner-finder-medication-mobile.d3a0caf6.svg";